export default {
    view_map: 'Prikaži mapu',
    no_offers: 'Ova kompanija trenutno nema nijednu uslugu.',
    no_offers_user: 'Ovaj korisnik trenutno nema nijednu uslugu.',
    no_results: 'Nije pronađen nijedan rezultat!',
}
